import { defineComponent as _defineComponent } from 'vue'
import TextField from "@/components/text-area.vue"
import CloseButton from "../buttons/close.vue";
import DetailsHeader from "./meeting-details-header.vue"
import {ref, watch} from 'vue'
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../util/firebase'
import { Meetings, FinancialUserspaces, InviteLinks, Userspaces } from '@busy-human/opt-library';
import { DataInstance } from "@busy-human/gearbox";
import Loader from '@/components/loader.vue';
import moment, { Moment } from 'moment';
import { useUserspace } from "@/store/userspace";



type Emits = {
    (e: "closePopup"): void
    (e: "deepClosePopup"): void
    (e: "moveToReschedule"): void
}
type Props = {
    selectedMeeting: DataInstance<Meetings.Model>
    name?: String,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'running-late',
  props: {
    selectedMeeting: null,
    name: null
  },
  emits: ["closePopup", "deepClosePopup", "moveToReschedule"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "closePopup"): void
    (e: "deepClosePopup"): void
    (e: "moveToReschedule"): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    selectedMeeting: DataInstance<Meetings.Model>
    name?: String,
}




const loading = ref(false)
const meetingMoment = ref<Moment>()
const otherUser = ref()
const collectorId = ref<string>("")
const payerId = ref<string>("")
const name = ref<string>("")

const message = ref<string>("")


watch(()=> props.selectedMeeting, async meeting =>{
    if(meeting){
        let meetingStart = new Date(meeting.startTime)
        meetingMoment.value = moment(meetingStart)

        if(meeting.payer){
            payerId.value = meeting.payer
        }
        if(meeting.collector){
            collectorId.value = meeting.collector
        }

        const currentUser = useUserspace().user

        if(currentUser.$id == meeting.collector){
            otherUser.value = await Userspaces.Collection.fetchDoc(meeting.payer)
            name.value = otherUser.value._data.name.fullName
        }else if(currentUser.$id == payerId.value){
            otherUser.value = await Userspaces.Collection.fetchDoc(meeting.collector)
            name.value = otherUser.value._data.name.fullName
        }
    }
},{immediate: true})

const closePopup = () => emit('closePopup');
const deepClosePopup = () => emit('deepClosePopup');

const reschedule = () =>{
    emit('moveToReschedule')
}

const sendRunningLateMessages = httpsCallable<{meetingId: string, userId: string, message: string}>(functions, 'sendRunningLateEmail')

const runningLate = async() => {
    loading.value = true;
    try{
        await sendRunningLateMessages({meetingId: props.selectedMeeting.$id, userId: useUserspace().uid, message: message.value})
        emit('deepClosePopup')
    }catch(e){
        console.error(e)
    }
    loading.value = false
    
}


const __returned__ = { emit, props, loading, meetingMoment, otherUser, collectorId, payerId, name, message, closePopup, deepClosePopup, reschedule, sendRunningLateMessages, runningLate, TextField, CloseButton, DetailsHeader, ref, watch, httpsCallable, functions, Meetings, FinancialUserspaces, InviteLinks, Userspaces, DataInstance, Loader, moment, Moment, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})